module.exports = __webpack_public_path__ + "static/home-3-d-4714a86c3e364aa04e8088cc6fc6b1af.mp4";